// interface IAddressBaseProps {
//   erro: any;
//   state: string;
//   city: string;
//   neighborhood: string;
//   street: string;
//   addrNumber: string;
//   postalCode: string;
// }

export interface IAddressProps {
  id: number;
  name?: string;
  country: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  addrNumber?: string;
  postalCode: string;
  complement?: string;
}

export interface IAddressCreateProps {
  name?: string;
  country: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  addrNumber?: string;
  postalCode: string;
  complement?: string;
}

export interface IAddressUpdateProps {
  name?: string;
  country: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  addrNumber?: string;
  postalCode: string;
  complement?: string;
}

export interface IAddressSimpleProps {
  name: string;
  state: string;
  city: string;
}

export const COUNTRYOPTIONS = [
  { label: 'Afeganistão', value: 'AF' },
  { label: 'África do Sul', value: 'ZA' },
  { label: 'Albânia', value: 'AL' },
  { label: 'Alemanha', value: 'DE' },
  { label: 'Andorra', value: 'AD' },
  { label: 'Angola', value: 'AO' },
  { label: 'Anguila', value: 'AI' },
  { label: 'Antártica', value: 'AQ' },
  { label: 'Antígua e Barbuda', value: 'AG' },
  { label: 'Arábia Saudita', value: 'SA' },
  { label: 'Argélia', value: 'DZ' },
  { label: 'Argentina', value: 'AR' },
  { label: 'Armênia', value: 'AM' },
  { label: 'Aruba', value: 'AW' },
  { label: 'Austrália', value: 'AU' },
  { label: 'Áustria', value: 'AT' },
  { label: 'Azerbaijão', value: 'AZ' },
  { label: 'Bahamas', value: 'BS' },
  { label: 'Bahrein', value: 'BH' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Bélgica', value: 'BE' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Benin', value: 'BJ' },
  { label: 'Bermudas', value: 'BM' },
  { label: 'Bielorrússia', value: 'BY' },
  { label: 'Bolívia', value: 'BO' },
  { label: 'Bósnia e Herzegovina', value: 'BA' },
  { label: 'Botsuana', value: 'BW' },
  { label: 'Brasil', value: 'BR' },
  { label: 'Brunei', value: 'BN' },
  { label: 'Bulgária', value: 'BG' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Butão', value: 'BT' },
  { label: 'Cabo Verde', value: 'CV' },
  { label: 'Camarões', value: 'CM' },
  { label: 'Camboja', value: 'KH' },
  { label: 'Canadá', value: 'CA' },
  { label: 'Catar', value: 'QA' },
  { label: 'Cazaquistão', value: 'KZ' },
  { label: 'Chile', value: 'CL' },
  { label: 'China', value: 'CN' },
  { label: 'Chipre', value: 'CY' },
  { label: 'Colômbia', value: 'CO' },
  { label: 'Comores', value: 'KM' },
  { label: 'Congo', value: 'CG' },
  { label: 'Congo (Rep. Democrática)', value: 'CD' },
  { label: 'Coreia do Sul', value: 'KR' },
  { label: 'Costa Rica', value: 'CR' },
  { label: 'Croácia', value: 'HR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Dinamarca', value: 'DK' },
  { label: 'Djibuti', value: 'DJ' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Egito', value: 'EG' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Emirados Árabes Unidos', value: 'AE' },
  { label: 'Equador', value: 'EC' },
  { label: 'Eritreia', value: 'ER' },
  { label: 'Eslováquia', value: 'SK' },
  { label: 'Eslovênia', value: 'SI' },
  { label: 'Espanha', value: 'ES' },
  { label: 'Estados Unidos', value: 'US' },
  { label: 'Estônia', value: 'EE' },
  { label: 'Eswatini', value: 'SZ' },
  { label: 'Etiópia', value: 'ET' },
  { label: 'Fiji', value: 'FJ' },
  { label: 'Filipinas', value: 'PH' },
  { label: 'Finlândia', value: 'FI' },
  { label: 'França', value: 'FR' },
  { label: 'Gabão', value: 'GA' },
  { label: 'Gâmbia', value: 'GM' },
  { label: 'Gana', value: 'GH' },
  { label: 'Geórgia', value: 'GE' },
  { label: 'Grécia', value: 'GR' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guiné', value: 'GN' },
  { label: 'Guiné-Bissau', value: 'GW' },
  { label: 'Guiné Equatorial', value: 'GQ' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Hungria', value: 'HU' },
  { label: 'Ilhas Åland', value: 'AX' },
  { label: 'Ilhas Cayman', value: 'KY' },
  { label: 'Índia', value: 'IN' },
  { label: 'Indonésia', value: 'ID' },
  { label: 'Irã', value: 'IR' },
  { label: 'Iraque', value: 'IQ' },
  { label: 'Irlanda', value: 'IE' },
  { label: 'Islândia', value: 'IS' },
  { label: 'Israel', value: 'IL' },
  { label: 'Itália', value: 'IT' },
  { label: 'Japão', value: 'JP' },
  { label: 'Jordânia', value: 'JO' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Lesoto', value: 'LS' },
  { label: 'Letônia', value: 'LV' },
  { label: 'Líbano', value: 'LB' },
  { label: 'Lituânia', value: 'LT' },
  { label: 'Luxemburgo', value: 'LU' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Malásia', value: 'MY' },
  { label: 'Maldivas', value: 'MV' },
  { label: 'Marrocos', value: 'MA' },
  { label: 'México', value: 'MX' },
  { label: 'Mônaco', value: 'MC' },
  { label: 'Moçambique', value: 'MZ' },
  { label: 'Namíbia', value: 'NA' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Nicarágua', value: 'NI' },
  { label: 'Nigéria', value: 'NG' },
  { label: 'Noruega', value: 'NO' },
  { label: 'Nova Zelândia', value: 'NZ' },
  { label: 'Omã', value: 'OM' },
  { label: 'Países Baixos', value: 'NL' },
  { label: 'Paquistão', value: 'PK' },
  { label: 'Panamá', value: 'PA' },
  { label: 'Paraguai', value: 'PY' },
  { label: 'Peru', value: 'PE' },
  { label: 'Polônia', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Reino Unido', value: 'GB' },
  { label: 'Romênia', value: 'RO' },
  { label: 'Rússia', value: 'RU' },
  { label: 'Senegal', value: 'SN' },
  { label: 'Sérvia', value: 'RS' },
  { label: 'Singapura', value: 'SG' },
  { label: 'Suécia', value: 'SE' },
  { label: 'Suíça', value: 'CH' },
  { label: 'Tailândia', value: 'TH' },
  { label: 'Turquia', value: 'TR' },
  { label: 'Ucrânia', value: 'UA' },
  { label: 'Uruguai', value: 'UY' },
  { label: 'Venezuela', value: 'VE' },
  { label: 'Vietnã', value: 'VN' },
  { label: 'Zâmbia', value: 'ZM' },
  { label: 'Zimbábue', value: 'ZW' },
];
